import './style.scss';
import {ACCEPTED_FILE_TYPES, MAX_FILE_SIZE, menuItems, MESSAGES} from '../../constants/index';
import UploadFile from "../../components/common/uploadFile";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {uploadDataItems} from "../../constants/index";
import {clearUploadErrors, uploadFiles} from "../../actions/uploads";
import SubNavigationTabs from "../../components/common/subNavigationTabs";
import {route as MY_DATA_ROUTE} from "../myData";

import excelImg from './excel.png';
import txtImg from './txt.png';
import UploadTab from "./uploadTab";
import Alert from "../../components/common/alert";
import {Navigate, useNavigate} from "react-router-dom";
import {setLoadingStatus} from "../../actions/session";
import {fetchSchools, getFileStatuses} from "../../actions/schools";
import {createSchoolsCanUploadList} from "../../utils/uploads";

export const route = '/upload-data';

const DEFAULT_UPLOAD_NOTE = 'Note: File must be less than 100MB';

export const uploadTabItems = {
  'xls-template': {
    label: 'Compass Excel Template',
    name: 'xls-template',
    instructions: <><a href="/UC_TES_File_Upload_Template.xlsx">Download Compass Template</a> and follow the instructions on the instructions tab.</>,
    sideImage: excelImg,
    sideImageAlt: 'Excel Template Icon',
    uploads: [
      {
        label: 'Upload Template',
        name: 'templateFile',
        note: DEFAULT_UPLOAD_NOTE,
        noFileMessage: 'No Compass Template Uploaded'
      }
    ]
  },
  'flat-file': {
    label: 'Flat File',
    name: 'flat-file',
    instructions: <><a href="/TES_Electronic_Transcript_Technical_Specification.pdf">Follow these instructions</a> for exporting the file from your SIS</>,
    sideImage: txtImg,
    sideImageAlt: 'Flat File Upload Icon',
    uploads: [
      {
        label: 'Upload Current File',
        name: 'currentFile',
        note: DEFAULT_UPLOAD_NOTE,
        noFileMessage: 'No Current File Uploaded'
      },
      {
        label: 'Upload Graduate File',
        name: 'graduateFile',
        note: DEFAULT_UPLOAD_NOTE,
        noFileMessage: 'No Graduate File Uploaded'
      }
    ]
  }
};

const UploadData = () => {
  const dispatch = useDispatch();

  const filesUploaded = useSelector((state) => state.uploads.filesUploaded);
  const currentDistrict = useSelector((state) => state.districts.currentDistrict);

  const [currentFile, setCurrentFile] = useState('');
  const [graduateFile, setGraduateFile] = useState('');
  const [templateFile, setTemplateFile] = useState('');
  const [school, setSchool] = useState(0);
  const [currentFileError, setCurrentFileError] = useState('');
  const [graduateFileError, setGraduateFileError] = useState('');
  const [templateFileError, setTemplateFileError] = useState('');
  const [schoolError, setSchoolError] = useState(null);
  const [schools, setSchools] = useState([]);
  const [schoolsLoaded, setSchoolsLoaded] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const uploadErrors = useSelector((state) => state.uploads.uploadErrors)

  const schoolList = useSelector((state) => state.schools.schools);

  useEffect(() => {
    if ((currentFile || graduateFile || templateFile) && school === 0) {
      setSchoolError('Please select a school to upload a file for')
    }

    async function returnFileStatuses(currentDistrict) {
      if (currentDistrict && (!schoolList) ) {
        await dispatch(setLoadingStatus(true));
        await dispatch(fetchSchools(currentDistrict));
        await dispatch(setLoadingStatus(false));
      }
    }

    returnFileStatuses(currentDistrict);

  }, [schoolList, currentDistrict, dispatch, currentFile, graduateFile, templateFile, school]);

  useEffect(() => {

    async function createSchoolList(schoolList){
      if (schoolList) {
        await setSchoolsLoaded(true);
        await setSchools(createSchoolsCanUploadList(schoolList));
      }
    }

    createSchoolList(schoolList);
  }, [schoolList]);

  let selectSchools = [];

  if (schools) {
    const schoolList = schools.map((school) => {
      return {
        id: school.id,
        name: `${school.atpCode} - ${school.name}`,
        accessDataStatus: school.accessDataStatus
      }
    });

    selectSchools = schoolList.slice();
    selectSchools.unshift({id: 0, name: 'Select a School'});
  }


  const onDismissAlert = () => {
    dispatch(clearUploadErrors());
  }

  const changeSchool = (schoolValue) => {
    const newSchool = schools.find((item) => item.id === parseInt(schoolValue));

    if (newSchool) {
      setSchool(newSchool);

      if (newSchool !== 0) {
        setSchoolError(null);
      }
    }
  }

  function validateFile(file, school, setError, uploadType) {

    if (!ACCEPTED_FILE_TYPES[uploadType].find((element) => element === file?.type)) {
      setError('Error: Wrong file type');
      return false;
    }

    if (file.size > MAX_FILE_SIZE) {
      setError('Error: File larger than 100MB');
      return false;
    }

    return true;
  }

  const handleSubmit = async (school) => {
    await setDisabled(true);
    await dispatch(setLoadingStatus(true));
    if (activeTab.name === 'flat-file') {
      await dispatch(uploadFiles(currentFile, school));
      await dispatch(uploadFiles(graduateFile, school));
    } else {
      await dispatch(uploadFiles(templateFile, school));
    }
    await dispatch(setLoadingStatus(false));
  }

  async function validateAndSetFile(file, school, setFile, setError, uploadType) {
    await setFile(null);
    activeTab['canUpload'] = false;
    //Want to clear the error before we validate
    await setError(null);

    if (validateFile(file, school, setError, uploadType)) {
      setFile(file);
    }
  }

  const uploadTabs = [uploadTabItems['xls-template'], uploadTabItems['flat-file']].map((tab) => {
    switch (tab.name) {
      case 'flat-file':
        tab['canUpload'] = (currentFile && graduateFile);
        break;
      case 'xls-template':
        tab['canUpload'] = (templateFile);
        break;
      default:
        tab['canUpload'] = false;
        break;
    }

    tab.uploads = tab.uploads.map((upload) => {
      let setUploadFile = null;
      let uploadFileError = null;
      let setUploadFileError = null;
      let uploadFile = null;
      let uploadType = '';

      switch (upload.name) {
        case 'currentFile':
          setUploadFile = setCurrentFile;
          uploadFileError = currentFileError;
          setUploadFileError = setCurrentFileError;
          uploadFile = currentFile;
          uploadType = 'legacy';
          break;
        case 'graduateFile':
          setUploadFile = setGraduateFile;
          uploadFileError = graduateFileError;
          setUploadFileError = setGraduateFileError;
          uploadFile = graduateFile;
          uploadType = 'legacy';
          break;
        case 'templateFile':
          setUploadFile = setTemplateFile;
          uploadFileError = templateFileError;
          setUploadFileError = setTemplateFileError;
          uploadFile = templateFile;
          uploadType = 'template';
          break;
        default:
          break;
      }

      upload['onChange'] = (target) => {
        validateAndSetFile(target, school, setUploadFile, setUploadFileError, uploadType);
      }
      upload['error'] = uploadFileError;
      upload['uploadFile'] = uploadFile;

      return upload;
    })
    return tab;
  });

  const [activeTab, setActiveTab] = useState(uploadTabs[0]);

  const uploadMenuItems = uploadDataItems.map((item, index) => {
    item['onClickAction'] = () => {
      switch (item.name) {
        case 'flat-file':
          setTemplateFile(null);
          break;
        case 'xls-template':
          setCurrentFile(null);
          setGraduateFile(null);
          break;
        default:
          break;
      }

      setSchoolError(null);
      setActiveTab(uploadTabs[index]);
    }
    return item;
  });

  return (filesUploaded ) ? <Navigate to={MY_DATA_ROUTE}/> : (
    <div className='main-content upload-data-content'>
      <SubNavigationTabs items={uploadMenuItems} currentTabName={activeTab.name}/>
      <div className='user-profile-header'>Upload Data</div>
      <div className='my-profile-alerts'>
        {(uploadErrors) && <Alert messageType='error' onDismiss={onDismissAlert}>{MESSAGES.UPLOADS.uploadFileApiError}</Alert>}
      </div>
      <div className='data-upload-container'>
        <UploadTab activeTab={activeTab} onSubmitAction={handleSubmit} school={school} changeSchool={changeSchool} selectSchools={selectSchools} schoolError={schoolError} submitDisabled={disabled}/>
      </div>
    </div>
  );
}

export default UploadData;
